const ProjectGoalsSkeletonLoader = () => (
  <div data-testid='project-goals-skeleton-loader'>
    <div className='animate-pulse bg-primary-lighter-two w-1/4 h-5 mb-4 mt-2' />
    <div className='animate-pulse bg-primary-lighter-two h-14 w-full' />
  </div>
);

export default ProjectGoalsSkeletonLoader;
